import React from 'react';

export default function Footer() {
    return (
        <footer className="footer text-center text-lg-start mt-auto">
            <div className="text-center p-3"> Bazzomir © 2025</div>
        </footer>
    )
}